mutation updateCompanyAmbassadorData($input: UpdateCompanyAmbassadorDataInput!) {
  ambassador: updateCompanyAmbassadorData(input: $input)
}
